/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useState } from 'react';
import { postRequest } from 'apis/ApiInstence';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';

const AddStory = () => {
    const [formData, setFormData] = useState({
        startupName: '',
        founderName: '',
        caseStudy: '',
        interview: '',
        videoUrl: '',
        growthMetrics: '',
        image: null
    });
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    const handleChange = (e) => {
        const { name, value, type } = e.target;
        setFormData(prevState => ({
            ...prevState,
            [name]: type === 'file' ? e.target.files[0] : value
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!formData.startupName || !formData.founderName) {
            toast.error("Startup Name and Founder Name are required!");
            return;
        }

        setLoading(true);
        const data = new FormData();
        for (const key in formData) {
            if (formData[key] !== null && formData[key] !== '') {
                data.append(key, formData[key]);
            }
        }

        try {
            await postRequest('success-stories', data);
            toast.success('Success story added successfully!');
            navigate('/stories');
        } catch (error) {
            console.error('Failed to add success story:', error);
            toast.error(error?.message || 'Error occurred while creating success story.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            <div className='container-fluid mt-5 mb-5'>
                <div className='mainheadig mx-4 mb-4'>
                    <h4 className='text-white font-weight-bold'>Add Success Story</h4>
                </div>
                <form onSubmit={handleSubmit} className="mx-4 p-4 card shadow">
                    <div className='row'>
                        <div className='col-sm-6 form-group'>
                            <label className='admin-label font-weight-bold'>Startup Name *</label>
                            <input
                                type='text'
                                name='startupName'
                                className='form-control'
                                value={formData.startupName}
                                onChange={handleChange}
                                placeholder="e.g. AgroFarm Solutions"
                                required
                            />
                        </div>

                        <div className='col-sm-6 form-group'>
                            <label className='admin-label font-weight-bold'>Founder Name(s) *</label>
                            <input
                                type='text'
                                name='founderName'
                                className='form-control'
                                value={formData.founderName}
                                onChange={handleChange}
                                placeholder="e.g. Ramesh Kumar"
                                required
                            />
                        </div>

                        <div className='col-sm-12 form-group mt-3'>
                            <label className='admin-label font-weight-bold'>Growth Metrics</label>
                            <textarea
                                name='growthMetrics'
                                className='form-control'
                                rows="3"
                                value={formData.growthMetrics}
                                onChange={handleChange}
                                placeholder="e.g. Revenue grew by 200%, Impacted 5000+ farmers, raised seed funding..."
                            ></textarea>
                        </div>

                        <div className='col-sm-12 form-group mt-3'>
                            <label className='admin-label font-weight-bold'>Case Study (Safalta ki Kahaani)</label>
                            <textarea
                                name='caseStudy'
                                className='form-control'
                                rows="5"
                                value={formData.caseStudy}
                                onChange={handleChange}
                                placeholder="Describe the startup's journey, problem solved, and how Jawahar R-ABI helped..."
                            ></textarea>
                        </div>

                        <div className='col-sm-12 form-group mt-3'>
                            <label className='admin-label font-weight-bold'>Founder Interview / Q&A</label>
                            <textarea
                                name='interview'
                                className='form-control'
                                rows="4"
                                value={formData.interview}
                                onChange={handleChange}
                                placeholder="Q: What was the main challenge? A: ..."
                            ></textarea>
                        </div>

                        <div className='col-sm-12 form-group mt-3'>
                            <label className='admin-label font-weight-bold'>YouTube Video Link</label>
                            <input
                                type='url'
                                name='videoUrl'
                                className='form-control'
                                value={formData.videoUrl}
                                onChange={handleChange}
                                placeholder="https://www.youtube.com/watch?v=..."
                            />
                        </div>

                        <div className='col-sm-12 form-group mt-3'>
                            <label className='admin-label font-weight-bold'>Cover Image / Startup Group Photo</label>
                            <input
                                type='file'
                                name='image'
                                className='form-control filebg'
                                onChange={handleChange}
                                accept="image/*"
                            />
                        </div>
                    </div>
                    
                    <div className='mt-4 text-right'>
                        <button
                            type="button"
                            className="btn btn-secondary mr-2"
                            onClick={() => navigate('/stories')}
                        >
                            Cancel
                        </button>
                        <button
                            type="submit"
                            className='btn addbtn pl-4 pr-4'
                            disabled={loading}
                        >
                            {loading ? 'Creating...' : 'Add Success Story'}
                        </button>
                    </div>
                </form>
            </div>
        </>
    );
};

export default AddStory;
